import { flatten as _flatten } from 'lodash';

// Helper function used for merging multiple offer responses into one
export function mergeOfferMatches(results: OfferResponse[]): OfferResponse {
    return {
        data: _flatten(
            results.map((result) => result.data),
        ),
    };
}

export interface OfferResponse<T = any> {
    data: T;
}
